export const nationalities_en = [
  {
    alpha2: 'AD',
    value: 'AND',
    display: 'Andorra',
  },
  {
    alpha2: 'AE',
    value: 'ARE',
    display: 'United Arab Emirates',
  },
  {
    alpha2: 'AF',
    value: 'AFG',
    display: 'Afghanistan',
  },
  {
    alpha2: 'AG',
    value: 'ATG',
    display: 'Antigua and Barbuda',
  },
  {
    alpha2: 'AI',
    value: 'AIA',
    display: 'Anguilla',
  },
  {
    alpha2: 'AL',
    value: 'ALB',
    display: 'Albania',
  },
  {
    alpha2: 'AM',
    value: 'ARM',
    display: 'Armenia',
  },
  {
    alpha2: 'AO',
    value: 'AGO',
    display: 'Angola',
  },
  {
    alpha2: 'AQ',
    value: 'ATA',
    display: 'Antarctica',
  },
  {
    alpha2: 'AR',
    value: 'ARG',
    display: 'Argentina',
  },
  {
    alpha2: 'AS',
    value: 'ASM',
    display: 'American Samoa',
  },
  {
    alpha2: 'AT',
    value: 'AUT',
    display: 'Austria',
  },
  {
    alpha2: 'AU',
    value: 'AUS',
    display: 'Australia',
  },
  {
    alpha2: 'AW',
    value: 'ABW',
    display: 'Aruba',
  },
  {
    alpha2: 'AX',
    value: 'ALA',
    display: 'Åland Islands',
  },
  {
    alpha2: 'AZ',
    value: 'AZE',
    display: 'Azerbaijan',
  },
  {
    alpha2: 'BA',
    value: 'BIH',
    display: 'Bosnia and Herzegovina',
  },
  {
    alpha2: 'BB',
    value: 'BRB',
    display: 'Barbados',
  },
  {
    alpha2: 'BD',
    value: 'BGD',
    display: 'Bangladesh',
  },
  {
    alpha2: 'BE',
    value: 'BEL',
    display: 'Belgium',
  },
  {
    alpha2: 'BF',
    value: 'BFA',
    display: 'Burkina Faso',
  },
  {
    alpha2: 'BG',
    value: 'BGR',
    display: 'Bulgaria',
  },
  {
    alpha2: 'BH',
    value: 'BHR',
    display: 'Bahrain',
  },
  {
    alpha2: 'BI',
    value: 'BDI',
    display: 'Burundi',
  },
  {
    alpha2: 'BJ',
    value: 'BEN',
    display: 'Benin',
  },
  {
    alpha2: 'BL',
    value: 'BLM',
    display: 'Saint Barthélemy',
  },
  {
    alpha2: 'BM',
    value: 'BMU',
    display: 'Bermuda',
  },
  {
    alpha2: 'BN',
    value: 'BRN',
    display: 'Brunei Darussalam',
  },
  {
    alpha2: 'BO',
    value: 'BOL',
    display: 'Bolivia (Plurinational State of)',
  },
  {
    alpha2: 'BQ',
    value: 'BES',
    display: 'Bonaire, Sint Eustatius and Saba',
  },
  {
    alpha2: 'BR',
    value: 'BRA',
    display: 'Brazil',
  },
  {
    alpha2: 'BS',
    value: 'BHS',
    display: 'Bahamas',
  },
  {
    alpha2: 'BT',
    value: 'BTN',
    display: 'Bhutan',
  },
  {
    alpha2: 'BV',
    value: 'BVT',
    display: 'Bouvet Island',
  },
  {
    alpha2: 'BW',
    value: 'BWA',
    display: 'Botswana',
  },
  {
    alpha2: 'BY',
    value: 'BLR',
    display: 'Belarus',
  },
  {
    alpha2: 'BZ',
    value: 'BLZ',
    display: 'Belize',
  },
  {
    alpha2: 'CA',
    value: 'CAN',
    display: 'Canada',
  },
  {
    alpha2: 'CC',
    value: 'CCK',
    display: 'Cocos (Keeling) Islands',
  },
  {
    alpha2: 'CD',
    value: 'COD',
    display: 'Congo, Democratic Republic of the',
  },
  {
    alpha2: 'CF',
    value: 'CAF',
    display: 'Central African Republic',
  },
  {
    alpha2: 'CG',
    value: 'COG',
    display: 'Congo',
  },
  {
    alpha2: 'CH',
    value: 'CHE',
    display: 'Switzerland',
  },
  {
    alpha2: 'CI',
    value: 'CIV',
    display: 'Côte d Ivoire',
  },
  {
    alpha2: 'CK',
    value: 'COK',
    display: 'Cook Islands',
  },
  {
    alpha2: 'CL',
    value: 'CHL',
    display: 'Chile',
  },
  {
    alpha2: 'CM',
    value: 'CMR',
    display: 'Cameroon',
  },
  {
    alpha2: 'CN',
    value: 'CHN',
    display: 'China',
  },
  {
    alpha2: 'CO',
    value: 'COL',
    display: 'Colombia',
  },
  {
    alpha2: 'CR',
    value: 'CRI',
    display: 'Costa Rica',
  },
  {
    alpha2: 'CU',
    value: 'CUB',
    display: 'Cuba',
  },
  {
    alpha2: 'CV',
    value: 'CPV',
    display: 'Cabo Verde',
  },
  {
    alpha2: 'CW',
    value: 'CUW',
    display: 'Curaçao',
  },
  {
    alpha2: 'CX',
    value: 'CXR',
    display: 'Christmas Island',
  },
  {
    alpha2: 'CY',
    value: 'CYP',
    display: 'Cyprus',
  },
  {
    alpha2: 'CZ',
    value: 'CZE',
    display: 'Czechia',
  },
  {
    alpha2: 'DE',
    value: 'DEU',
    display: 'Germany',
  },
  {
    alpha2: 'DJ',
    value: 'DJI',
    display: 'Djibouti',
  },
  {
    alpha2: 'DK',
    value: 'DNK',
    display: 'Denmark',
  },
  {
    alpha2: 'DM',
    value: 'DMA',
    display: 'Dominica',
  },
  {
    alpha2: 'DO',
    value: 'DOM',
    display: 'Dominican Republic',
  },
  {
    alpha2: 'DZ',
    value: 'DZA',
    display: 'Algeria',
  },
  {
    alpha2: 'EC',
    value: 'ECU',
    display: 'Ecuador',
  },
  {
    alpha2: 'EE',
    value: 'EST',
    display: 'Estonia',
  },
  {
    alpha2: 'EG',
    value: 'EGY',
    display: 'Egypt',
  },
  {
    alpha2: 'EH',
    value: 'ESH',
    display: 'Western Sahara',
  },
  {
    alpha2: 'ER',
    value: 'ERI',
    display: 'Eritrea',
  },
  {
    alpha2: 'ES',
    value: 'ESP',
    display: 'Spain',
  },
  {
    alpha2: 'ET',
    value: 'ETH',
    display: 'Ethiopia',
  },
  {
    alpha2: 'FI',
    value: 'FIN',
    display: 'Finland',
  },
  {
    alpha2: 'FJ',
    value: 'FJI',
    display: 'Fiji',
  },
  {
    alpha2: 'FK',
    value: 'FLK',
    display: 'Falkland Islands (Malvinas)',
  },
  {
    alpha2: 'FM',
    value: 'FSM',
    display: 'Micronesia (Federated States of)',
  },
  {
    alpha2: 'FO',
    value: 'FRO',
    display: 'Faroe Islands',
  },
  {
    alpha2: 'FR',
    value: 'FRA',
    display: 'France',
  },
  {
    alpha2: 'GA',
    value: 'GAB',
    display: 'Gabon',
  },
  {
    alpha2: 'GB',
    value: 'GBR',
    display: 'United Kingdom of Great Britain and Northern Ireland',
  },
  {
    alpha2: 'GD',
    value: 'GRD',
    display: 'Grenada',
  },
  {
    alpha2: 'GE',
    value: 'GEO',
    display: 'Georgia',
  },
  {
    alpha2: 'GF',
    value: 'GUF',
    display: 'French Guiana',
  },
  {
    alpha2: 'GG',
    value: 'GGY',
    display: 'Guernsey',
  },
  {
    alpha2: 'GH',
    value: 'GHA',
    display: 'Ghana',
  },
  {
    alpha2: 'GI',
    value: 'GIB',
    display: 'Gibraltar',
  },
  {
    alpha2: 'GL',
    value: 'GRL',
    display: 'Greenland',
  },
  {
    alpha2: 'GM',
    value: 'GMB',
    display: 'Gambia',
  },
  {
    alpha2: 'GN',
    value: 'GIN',
    display: 'Guinea',
  },
  {
    alpha2: 'GP',
    value: 'GLP',
    display: 'Guadeloupe',
  },
  {
    alpha2: 'GQ',
    value: 'GNQ',
    display: 'Equatorial Guinea',
  },
  {
    alpha2: 'GR',
    value: 'GRC',
    display: 'Greece',
  },
  {
    alpha2: 'GS',
    value: 'SGS',
    display: 'South Georgia and the South Sandwich Islands',
  },
  {
    alpha2: 'GT',
    value: 'GTM',
    display: 'Guatemala',
  },
  {
    alpha2: 'GU',
    value: 'GUM',
    display: 'Guam',
  },
  {
    alpha2: 'GW',
    value: 'GNB',
    display: 'Guinea-Bissau',
  },
  {
    alpha2: 'GY',
    value: 'GUY',
    display: 'Guyana',
  },
  {
    alpha2: 'HK',
    value: 'HKG',
    display: 'Hong Kong',
  },
  {
    alpha2: 'HM',
    value: 'HMD',
    display: 'Heard Island and McDonald Islands',
  },
  {
    alpha2: 'HN',
    value: 'HND',
    display: 'Honduras',
  },
  {
    alpha2: 'HR',
    value: 'HRV',
    display: 'Croatia',
  },
  {
    alpha2: 'HT',
    value: 'HTI',
    display: 'Haiti',
  },
  {
    alpha2: 'HU',
    value: 'HUN',
    display: 'Hungary',
  },
  {
    alpha2: 'ID',
    value: 'IDN',
    display: 'Indonesia',
  },
  {
    alpha2: 'IE',
    value: 'IRL',
    display: 'Ireland',
  },
  {
    alpha2: 'IL',
    value: 'ISR',
    display: 'Israel',
  },
  {
    alpha2: 'IM',
    value: 'IMN',
    display: 'Isle of Man',
  },
  {
    alpha2: 'IN',
    value: 'IND',
    display: 'India',
  },
  {
    alpha2: 'IO',
    value: 'IOT',
    display: 'British Indian Ocean Territory',
  },
  {
    alpha2: 'IQ',
    value: 'IRQ',
    display: 'Iraq',
  },
  {
    alpha2: 'IR',
    value: 'IRN',
    display: 'Iran (Islamic Republic of)',
  },
  {
    alpha2: 'IS',
    value: 'ISL',
    display: 'Iceland',
  },
  {
    alpha2: 'IT',
    value: 'ITA',
    display: 'Italy',
  },
  {
    alpha2: 'JE',
    value: 'JEY',
    display: 'Jersey',
  },
  {
    alpha2: 'JM',
    value: 'JAM',
    display: 'Jamaica',
  },
  {
    alpha2: 'JO',
    value: 'JOR',
    display: 'Jordan',
  },
  {
    alpha2: 'JP',
    value: 'JPN',
    display: 'Japan',
  },
  {
    alpha2: 'KE',
    value: 'KEN',
    display: 'Kenya',
  },
  {
    alpha2: 'KG',
    value: 'KGZ',
    display: 'Kyrgyzstan',
  },
  {
    alpha2: 'KH',
    value: 'KHM',
    display: 'Cambodia',
  },
  {
    alpha2: 'KI',
    value: 'KIR',
    display: 'Kiribati',
  },
  {
    alpha2: 'KM',
    value: 'COM',
    display: 'Comoros',
  },
  {
    alpha2: 'KN',
    value: 'KNA',
    display: 'Saint Kitts and Nevis',
  },
  {
    alpha2: 'KP',
    value: 'PRK',
    display: 'Korea (Democratic Peoples Republic of)',
  },
  {
    alpha2: 'KR',
    value: 'KOR',
    display: 'Korea, Republic of',
  },
  {
    alpha2: 'KW',
    value: 'KWT',
    display: 'Kuwait',
  },
  {
    alpha2: 'KY',
    value: 'CYM',
    display: 'Cayman Islands',
  },
  {
    alpha2: 'KZ',
    value: 'KAZ',
    display: 'Kazakhstan',
  },
  {
    alpha2: 'LA',
    value: 'LAO',
    display: 'Lao Peoples Democratic Republic',
  },
  {
    alpha2: 'LB',
    value: 'LBN',
    display: 'Lebanon',
  },
  {
    alpha2: 'LC',
    value: 'LCA',
    display: 'Saint Lucia',
  },
  {
    alpha2: 'LI',
    value: 'LIE',
    display: 'Liechtenstein',
  },
  {
    alpha2: 'LK',
    value: 'LKA',
    display: 'Sri Lanka',
  },
  {
    alpha2: 'LR',
    value: 'LBR',
    display: 'Liberia',
  },
  {
    alpha2: 'LS',
    value: 'LSO',
    display: 'Lesotho',
  },
  {
    alpha2: 'LT',
    value: 'LTU',
    display: 'Lithuania',
  },
  {
    alpha2: 'LU',
    value: 'LUX',
    display: 'Luxembourg',
  },
  {
    alpha2: 'LV',
    value: 'LVA',
    display: 'Latvia',
  },
  {
    alpha2: 'LY',
    value: 'LBY',
    display: 'Libya',
  },
  {
    alpha2: 'MA',
    value: 'MAR',
    display: 'Morocco',
  },
  {
    alpha2: 'MC',
    value: 'MCO',
    display: 'Monaco',
  },
  {
    alpha2: 'MD',
    value: 'MDA',
    display: 'Moldova, Republic of',
  },
  {
    alpha2: 'ME',
    value: 'MNE',
    display: 'Montenegro',
  },
  {
    alpha2: 'MF',
    value: 'MAF',
    display: 'Saint Martin (French part)',
  },
  {
    alpha2: 'MG',
    value: 'MDG',
    display: 'Madagascar',
  },
  {
    alpha2: 'MH',
    value: 'MHL',
    display: 'Marshall Islands',
  },
  {
    alpha2: 'MK',
    value: 'MKD',
    display: 'North Macedonia',
  },
  {
    alpha2: 'ML',
    value: 'MLI',
    display: 'Mali',
  },
  {
    alpha2: 'MM',
    value: 'MMR',
    display: 'Myanmar',
  },
  {
    alpha2: 'MN',
    value: 'MNG',
    display: 'Mongolia',
  },
  {
    alpha2: 'MO',
    value: 'MAC',
    display: 'Macao',
  },
  {
    alpha2: 'MP',
    value: 'MNP',
    display: 'Northern Mariana Islands',
  },
  {
    alpha2: 'MQ',
    value: 'MTQ',
    display: 'Martinique',
  },
  {
    alpha2: 'MR',
    value: 'MRT',
    display: 'Mauritania',
  },
  {
    alpha2: 'MS',
    value: 'MSR',
    display: 'Montserrat',
  },
  {
    alpha2: 'MT',
    value: 'MLT',
    display: 'Malta',
  },
  {
    alpha2: 'MU',
    value: 'MUS',
    display: 'Mauritius',
  },
  {
    alpha2: 'MV',
    value: 'MDV',
    display: 'Maldives',
  },
  {
    alpha2: 'MW',
    value: 'MWI',
    display: 'Malawi',
  },
  {
    alpha2: 'MX',
    value: 'MEX',
    display: 'Mexico',
  },
  {
    alpha2: 'MY',
    value: 'MYS',
    display: 'Malaysia',
  },
  {
    alpha2: 'MZ',
    value: 'MOZ',
    display: 'Mozambique',
  },
  {
    alpha2: 'NA',
    value: 'NAM',
    display: 'Namibia',
  },
  {
    alpha2: 'NC',
    value: 'NCL',
    display: 'New Caledonia',
  },
  {
    alpha2: 'NE',
    value: 'NER',
    display: 'Niger',
  },
  {
    alpha2: 'NF',
    value: 'NFK',
    display: 'Norfolk Island',
  },
  {
    alpha2: 'NG',
    value: 'NGA',
    display: 'Nigeria',
  },
  {
    alpha2: 'NI',
    value: 'NIC',
    display: 'Nicaragua',
  },
  {
    alpha2: 'NL',
    value: 'NLD',
    display: 'Netherlands',
  },
  {
    alpha2: 'NO',
    value: 'NOR',
    display: 'Norway',
  },
  {
    alpha2: 'NP',
    value: 'NPL',
    display: 'Nepal',
  },
  {
    alpha2: 'NR',
    value: 'NRU',
    display: 'Nauru',
  },
  {
    alpha2: 'NU',
    value: 'NIU',
    display: 'Niue',
  },
  {
    alpha2: 'NZ',
    value: 'NZL',
    display: 'New Zealand',
  },
  {
    alpha2: 'OM',
    value: 'OMN',
    display: 'Oman',
  },
  {
    alpha2: 'PA',
    value: 'PAN',
    display: 'Panama',
  },
  {
    alpha2: 'PE',
    value: 'PER',
    display: 'Peru',
  },
  {
    alpha2: 'PF',
    value: 'PYF',
    display: 'French Polynesia',
  },
  {
    alpha2: 'PG',
    value: 'PNG',
    display: 'Papua New Guinea',
  },
  {
    alpha2: 'PH',
    value: 'PHL',
    display: 'Philippines',
  },
  {
    alpha2: 'PK',
    value: 'PAK',
    display: 'Pakistan',
  },
  {
    alpha2: 'PL',
    value: 'POL',
    display: 'Poland',
  },
  {
    alpha2: 'PM',
    value: 'SPM',
    display: 'Saint Pierre and Miquelon',
  },
  {
    alpha2: 'PN',
    value: 'PCN',
    display: 'Pitcairn',
  },
  {
    alpha2: 'PR',
    value: 'PRI',
    display: 'Puerto Rico',
  },
  {
    alpha2: 'PS',
    value: 'PSE',
    display: 'Palestine, State of',
  },
  {
    alpha2: 'PT',
    value: 'PRT',
    display: 'Portugal',
  },
  {
    alpha2: 'PW',
    value: 'PLW',
    display: 'Palau',
  },
  {
    alpha2: 'PY',
    value: 'PRY',
    display: 'Paraguay',
  },
  {
    alpha2: 'QA',
    value: 'QAT',
    display: 'Qatar',
  },
  {
    alpha2: 'RE',
    value: 'REU',
    display: 'Réunion',
  },
  {
    alpha2: 'RO',
    value: 'ROU',
    display: 'Romania',
  },
  {
    alpha2: 'RS',
    value: 'SRB',
    display: 'Serbia',
  },
  {
    alpha2: 'RU',
    value: 'RUS',
    display: 'Russian Federation',
  },
  {
    alpha2: 'RW',
    value: 'RWA',
    display: 'Rwanda',
  },
  {
    alpha2: 'SA',
    value: 'SAU',
    display: 'Saudi Arabia',
  },
  {
    alpha2: 'SB',
    value: 'SLB',
    display: 'Solomon Islands',
  },
  {
    alpha2: 'SC',
    value: 'SYC',
    display: 'Seychelles',
  },
  {
    alpha2: 'SD',
    value: 'SDN',
    display: 'Sudan',
  },
  {
    alpha2: 'SE',
    value: 'SWE',
    display: 'Sweden',
  },
  {
    alpha2: 'SG',
    value: 'SGP',
    display: 'Singapore',
  },
  {
    alpha2: 'SH',
    value: 'SHN',
    display: 'Saint Helena, Ascension and Tristan da Cunha',
  },
  {
    alpha2: 'SI',
    value: 'SVN',
    display: 'Slovenia',
  },
  {
    alpha2: 'SJ',
    value: 'SJM',
    display: 'Svalbard and Jan Mayen',
  },
  {
    alpha2: 'SK',
    value: 'SVK',
    display: 'Slovakia',
  },
  {
    alpha2: 'SL',
    value: 'SLE',
    display: 'Sierra Leone',
  },
  {
    alpha2: 'SM',
    value: 'SMR',
    display: 'San Marino',
  },
  {
    alpha2: 'SN',
    value: 'SEN',
    display: 'Senegal',
  },
  {
    alpha2: 'SO',
    value: 'SOM',
    display: 'Somalia',
  },
  {
    alpha2: 'SR',
    value: 'SUR',
    display: 'Suriname',
  },
  {
    alpha2: 'SS',
    value: 'SSD',
    display: 'South Sudan',
  },
  {
    alpha2: 'ST',
    value: 'STP',
    display: 'Sao Tome and Principe',
  },
  {
    alpha2: 'SV',
    value: 'SLV',
    display: 'El Salvador',
  },
  {
    alpha2: 'SX',
    value: 'SXM',
    display: 'Sint Maarten (Dutch part)',
  },
  {
    alpha2: 'SY',
    value: 'SYR',
    display: 'Syrian Arab Republic',
  },
  {
    alpha2: 'SZ',
    value: 'SWZ',
    display: 'Eswatini',
  },
  {
    alpha2: 'TC',
    value: 'TCA',
    display: 'Turks and Caicos Islands',
  },
  {
    alpha2: 'TD',
    value: 'TCD',
    display: 'Chad',
  },
  {
    alpha2: 'TF',
    value: 'ATF',
    display: 'French Southern Territories',
  },
  {
    alpha2: 'TG',
    value: 'TGO',
    display: 'Togo',
  },
  {
    alpha2: 'TH',
    value: 'THA',
    display: 'Thailand',
  },
  {
    alpha2: 'TJ',
    value: 'TJK',
    display: 'Tajikistan',
  },
  {
    alpha2: 'TK',
    value: 'TKL',
    display: 'Tokelau',
  },
  {
    alpha2: 'TL',
    value: 'TLS',
    display: 'Timor-Leste',
  },
  {
    alpha2: 'TM',
    value: 'TKM',
    display: 'Turkmenistan',
  },
  {
    alpha2: 'TN',
    value: 'TUN',
    display: 'Tunisia',
  },
  {
    alpha2: 'TO',
    value: 'TON',
    display: 'Tonga',
  },
  {
    alpha2: 'TR',
    value: 'TUR',
    display: 'Türkiye',
  },
  {
    alpha2: 'TT',
    value: 'TTO',
    display: 'Trinidad and Tobago',
  },
  {
    alpha2: 'TV',
    value: 'TUV',
    display: 'Tuvalu',
  },
  {
    alpha2: 'TW',
    value: 'TWN',
    display: 'Taiwan, Province of China',
  },
  {
    alpha2: 'TZ',
    value: 'TZA',
    display: 'Tanzania, United Republic of',
  },
  {
    alpha2: 'UA',
    value: 'UKR',
    display: 'Ukraine',
  },
  {
    alpha2: 'UG',
    value: 'UGA',
    display: 'Uganda',
  },
  {
    alpha2: 'UM',
    value: 'UMI',
    display: 'United States Minor Outlying Islands',
  },
  {
    alpha2: 'US',
    value: 'USA',
    display: 'United States of America',
  },
  {
    alpha2: 'UY',
    value: 'URY',
    display: 'Uruguay',
  },
  {
    alpha2: 'UZ',
    value: 'UZB',
    display: 'Uzbekistan',
  },
  {
    alpha2: 'VA',
    value: 'VAT',
    display: 'Holy See',
  },
  {
    alpha2: 'VC',
    value: 'VCT',
    display: 'Saint Vincent and the Grenadines',
  },
  {
    alpha2: 'VE',
    value: 'VEN',
    display: 'Venezuela (Bolivarian Republic of)',
  },
  {
    alpha2: 'VG',
    value: 'VGB',
    display: 'Virgin Islands (British)',
  },
  {
    alpha2: 'VI',
    value: 'VIR',
    display: 'Virgin Islands (U.S.)',
  },
  {
    alpha2: 'VN',
    value: 'VNM',
    display: 'Viet Nam',
  },
  {
    alpha2: 'VU',
    value: 'VUT',
    display: 'Vanuatu',
  },
  {
    alpha2: 'WF',
    value: 'WLF',
    display: 'Wallis and Futuna',
  },
  {
    alpha2: 'WS',
    value: 'WSM',
    display: 'Samoa',
  },
  {
    alpha2: 'YE',
    value: 'YEM',
    display: 'Yemen',
  },
  {
    alpha2: 'YT',
    value: 'MYT',
    display: 'Mayotte',
  },
  {
    alpha2: 'ZA',
    value: 'ZAF',
    display: 'South Africa',
  },
  {
    alpha2: 'ZM',
    value: 'ZMB',
    display: 'Zambia',
  },
  {
    alpha2: 'ZW',
    value: 'ZWE',
    display: 'Zimbabwe',
  },
];
